import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IpDataService {
  private sharedIpDataSubject = new BehaviorSubject<any>(null);
  sharedIpData$ = this.sharedIpDataSubject.asObservable();

  constructor() {}

  setSharedIpData(data: any) {
    this.sharedIpDataSubject.next(data);
  }
}
